export default {
  Public: 'Public',
  Private: 'Private',
};
